import { PlatformItemRes } from '../../api/Filing'

interface State {
  platformList: PlatformItemRes[]
  formData: any
}
type ActionType =
  | 'setFormDataAction'
  | 'resetStateAction'
  | 'setPlatformListAction'

interface Action {
  type: ActionType
  payload: any
}

export const initialState: State = {
  formData: {},
  platformList: [],
}

export default function reducer(
  state: State = initialState,
  action: Action,
): State {
  const newstate = { ...state }
  switch (action.type) {
    case 'setFormDataAction':
      newstate.formData = action.payload
      return newstate
    case 'setPlatformListAction':
      newstate.platformList = action.payload
      return newstate
    case 'resetStateAction':
      return initialState
    default:
      return newstate
  }
}

/**
 * 保存表单数据
 * @param val
 * @returns
 */
export const setFormDataAction = (val: any): Action => ({
  type: 'setFormDataAction',
  payload: val,
})

export const setPlatformListAction = (val: PlatformItemRes[]): Action => ({
  type: 'setPlatformListAction',
  payload: val,
})
/**
 * 重置redux内容，关闭页面时调用
 * @returns
 */
export const resetStateAction = (): Action => ({
  type: 'resetStateAction',
  payload: undefined,
})
import { PlatformItemRes } from '../../api/Filing'

interface State {
  platformList: PlatformItemRes[]
  formData: any
}
type ActionType =
  | 'setFormDataAction'
  | 'resetStateAction'
  | 'setPlatformListAction'

interface Action {
  type: ActionType
  payload: any
}

export const initialState: State = {
  formData: {},
  platformList: [],
}

export default function reducer(
  state: State = initialState,
  action: Action,
): State {
  const newstate = { ...state }
  switch (action.type) {
    case 'setFormDataAction':
      newstate.formData = action.payload
      return newstate
    case 'setPlatformListAction':
      newstate.platformList = action.payload
      return newstate
    case 'resetStateAction':
      return initialState
    default:
      return newstate
  }
}

/**
 * 保存表单数据
 * @param val
 * @returns
 */
export const setFormDataAction = (val: any): Action => ({
  type: 'setFormDataAction',
  payload: val,
})

export const setPlatformListAction = (val: PlatformItemRes[]): Action => ({
  type: 'setPlatformListAction',
  payload: val,
})
/**
 * 重置redux内容，关闭页面时调用
 * @returns
 */
export const resetStateAction = (): Action => ({
  type: 'resetStateAction',
  payload: undefined,
})
